import { regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { __awaiter } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';

function videoLoad(src) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            var video = document.createElement("video");
            var source = document.createElement("source");
            video.addEventListener("error", function () {
              resolve();
            });
            video.addEventListener("canplay", function () {
              resolve();
            });
            source.src = src;
            source.type = "video/mp4";
            video.appendChild(source);
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
function imageLoad(src, srcset, sizes) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", new Promise(function (resolve) {
            var image = new Image();
            image.addEventListener("load", function () {
              if (image.complete && image.naturalWidth) {
                resolve();
              }
            });
            image.addEventListener("error", function () {
              resolve();
            });
            if (srcset && typeof image.srcset !== "undefined") {
              image.srcset = srcset;
              image.sizes = sizes !== null && sizes !== void 0 ? sizes : "";
            } else {
              image.src = src;
            }
          }));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
}

export { imageLoad, videoLoad };
